// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Im8F","name":"styles_name__3sx6C","phone":"styles_phone__3WesC"};